import { useState } from 'react';
import { t } from 'ttag';
import classNames from 'classnames';

import { FeedFilterTitle } from '@components/FeedFilterTitle';
import { Checkbox } from '@ui/Checkbox';
import { Input } from '@ui/Input';

// styles
import s from './FeedPriceFilter.sss';

// types
type PriceOptions = {
  id: number | string;
  name: string;
  priceTo?: number | null;
  priceFrom?: number | null;
};

export type FeedPriceFilterProps = {
  options: PriceOptions[];
  valueFrom?: string;
  valueTo?: string;
  selectedPrices: number[];
  isMobile: boolean;
  select: (id: number) => void;
  onChange: (name: 'to' | 'from', e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const FeedPriceFilter: React.FC<FeedPriceFilterProps> = ({
  options,
  selectedPrices,
  select,
  onChange,
  valueFrom,
  valueTo,
  isMobile,
}) => {
  const [isHide, setHide] = useState(false);

  return (
    (
      <div className={classNames([s.root, { [s.mobile]: isMobile }])}>
        <FeedFilterTitle
          title={t`Ціна`}
          hide={isHide}
          onClick={() => setHide(!isHide)}
        />
        { !isHide && (
        <>
          {options.map((data) => (
            <Checkbox
              key={data.id}
              onCheck={() => select(+data.id)}
              checked={selectedPrices.includes(+data.id)}
              className={s.checkbox}
            >
              <span className={s.checkboxInput}>
                {data.name}
              </span>
            </Checkbox>
          ))}
          <div className={s.inputsWrapper}>
            <Input
              type="number"
              placeholder={t`Від`}
              className={s.fromPrice}
              value={valueFrom}
              onChange={(e) => onChange('from', e)}
            />
            <Input
              name="to"
              type="number"
              className={s.inputPrice}
              placeholder={t`До`}
              value={valueTo}
              onChange={(e) => onChange('to', e)}
            />
          </div>
        </>
        )}
      </div>
    )
  );
};

export default FeedPriceFilter;
